<template>
    <div class="maximize-promo">
        <section-header title="Maximize on the Payment Scale" icon="fa-money-bill-trend-up"/>
        <div class="info-box is-card is-stacked mb-5">
        <div class="box-main">
            <div class="box-body">
                <div class="box-title"><i class="fad fa-layer-group has-text-primary mr-2"></i>Build Your Own Bundle</div>
                <div class="my-3"><span class="promo-badge">Save 33% when bundling</span></div>
                <div class="box-text">Buy clock hours once at bundle pricing and spend them across any courses in the catalog &mdash; 33% less than enrolling course by course.</div>
                <div class="box-text has-text-weight-bold mt-2"><i class="fas fa-arrow-right has-text-primary mr-2"></i>Earn now, pay later.</div>
                <div class="box-text">Finance it with nothing due today and earn your raise before payments start.</div>
            </div>
        </div>
        <div class="box-actions">
            <div class="box-buttons">
                <b-button type="is-primary" size="is-small" tag="router-link" :to="{name: 'package-builder'}"><i class="fas fa-layer-group mr-2"></i>Build a Custom Course Bundle</b-button>
            </div>
        </div>
    </div>

        <div class="info-box is-card is-stacked mb-6">
        <div class="box-main">
            <div class="box-body">
                <div class="box-title"><i class="fad fa-messages-question has-text-primary mr-2"></i>Need a Hand?</div>
                <div class="box-text">A representative can look at your professional development as a whole &mdash; where you are on the salary schedule, what your renewal needs, and the fastest route to both &mdash; then choose courses with you and handle enrollment and payment setup for you.</div>
            </div>
        </div>
        <div class="box-actions">
            <div class="box-buttons">
                <b-button type="is-primary" outlined size="is-small" tag="router-link" :to="{name: 'package-builder', query: {phase: 'lead'}}"><i class="far fa-phone mr-2"></i>Work With a Representative</b-button>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import SectionHeader from "../framework/SectionHeader";

    /**
     * "Maximize on the Payment Scale": the bundle card and the representative
     * hand-off, as a narrow side column. Shared by the dashboard and the
     * Professional Development overview (copy mirrors the builder's entry
     * screen, PackageEntry.vue).
     */
    export default {
        name: "MaximizePromo",
        components: {SectionHeader},
    };
</script>

<style lang="scss" scoped>
    // Narrow-column boxes: no icon column; the footer keeps the standard
    // right-aligned small buttons
    .info-box.is-stacked {
        ::v-deep .box-main .box-icon {
            display: none;
        }
    }

    // Same green pill as the course catalog's bundle promo
    .promo-badge {
        display: inline-block;
        background: #e7f4ec;
        color: #2e7d4f;
        font-size: 0.7rem;
        font-weight: 900;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        padding: 3px 10px;
        border-radius: 999px;
    }
</style>
